import { render, staticRenderFns } from "./turnPerformanceList.vue?vue&type=template&id=7084f786&scoped=true&"
import script from "./turnPerformanceList.vue?vue&type=script&lang=js&"
export * from "./turnPerformanceList.vue?vue&type=script&lang=js&"
import style0 from "./turnPerformanceList.vue?vue&type=style&index=0&id=7084f786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7084f786",
  null
  
)

export default component.exports